import React from 'react';
import { useDixa } from 'ggApp/modules/dixa/hooks';

/**
 * Requires activeLanguage prop
 */
function withDixaMessenger(Component) {
    return function ComponentWithDixaMessenger(props) {
        const { activeLanguage } = props;
        if (!activeLanguage) {
            throw Error('withDixaMessenger HOC requires "activeLanguage" prop set.');
        }

        const { show: showDixaMessenger } = useDixa(activeLanguage);
        return <Component {...props} showDixaMessenger={showDixaMessenger} />;
    };
}

export { withDixaMessenger };
